import type {
	IHistoryEntry,
	ITicket,
	IVisitedLocation,
	TMaybeTicket,
} from '../store';

type TSortResult = -1 | 0 | 1;

export class Sorting {
	public static sortTicketByClosedDateDesc(a: TMaybeTicket, b: TMaybeTicket): TSortResult {
		if(a === null || b === null) {
			return 0;
		}

		return Sorting.sortByField<ITicket>('closedDate', a, b);
	}

	public static sortVisitedLocationsByMostRecent(a: IVisitedLocation, b: IVisitedLocation): TSortResult {
		return Sorting.sortByField<IVisitedLocation>('lastVisit', a, b);
	}

	public static sortHistoryEntriesByCheckoutDateDesc(a: IHistoryEntry, b: IHistoryEntry): TSortResult {
		return Sorting.sortByField<IHistoryEntry>('checkoutDate', a, b);
	}

	private static sortByField<T>(fieldName: keyof T, a: T, b: T, reverse = false): TSortResult {
		if(typeof a?.[fieldName] === 'undefined' ||
			typeof b?.[fieldName] === 'undefined' ||
			a[fieldName] === null ||
			b[fieldName] === null
		) {
			return 0;
		}

		if(a[fieldName] > b[fieldName]) {
			return reverse ? 1 : -1;
		} else if(a[fieldName] < b[fieldName]) {
			return reverse ? -1 : 1;
		}

		return 0;
	}
}
